<template>
  <div v-if="!fetching" class="mt-8 flex flex-col">
    <h3
      class="py-4 text-center text-gray-500 bg-white rounded-md"
      v-show="rep_table_data.length == 0"
    >
      {{ not_records_found }}
    </h3>
    <div v-show="rep_table_data.length > 0">
      <div class="flex flex-row justify-start">
      <div class="panel-plain-label">
        <badge-default
          :label="
            rep_table_data.length + ' ' + number_rows_label
          "
        />
      </div>
    </div>
      <div v-show="rep_table_data.length > 0" class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th
                    v-for="(group_header, index) in rep_table_headers"
                    :key="index"
                    scope="col"
                    :class="[
                      'table-header-cell border text-center',
                      bgColor(group_header.color)
                    ]"
                    :colspan="Number(group_header.columns.length)"
                  >
                    {{ group_header.label }}
                  </th>
                </tr>
                <tr>
                  <th
                    v-for="(header, index) in headers"
                    :key="index"
                    scope="col"
                    :class="['table-header-cell border', bgColor(header.color)]"
                  >
                    {{ header.label }}
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="(row, index) in rep_table_data"
                  :key="index"
                >
                  <td
                    v-for="(cell, idx) in row"
                    :key="idx"
                    :class="[
                      'border',
                      rep_table_data.length - 1 == index && row[0].value == null
                        ? 'table-cell-main'
                        : 'table-cell'
                    ]"
                  >
                    {{ cellValue(cell) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <loading-message v-else />
</template>

<script>
export default {
  name: "QrTable",
  props: {
    rep_table_headers: {
      type: Array,
      required: true
    },
    rep_table_data: {
      type: Array,
      required: false,
      default: () => []
    },
    number_rows_label: { type: String, default: "Records" },
    not_records_found: { type: String, default: "No records found" },
    fetching: {}
  },
  computed: {
    headers: function () {
      return this.rep_table_headers.map(header => header.columns).flat();
    }
  },
  methods: {
    cellValue: function (cell) {
      if (
        !isNaN(Number(cell.value)) &&
        ["#.#%", "#,###.##", "#"].includes(cell.number_format)
      ) {
        if (cell.value == 0 || cell.value == null) return "";
        const style = this.formatStyle(cell.number_format);
        return Number(cell.value).toLocaleString(undefined, {
          style: style
        });
      } else if (!isNaN(Date.parse(cell.value))) {
        return this.dateFormatter(cell.value);
      } else {
        return cell.value;
      }
    },
    formatStyle: function (number_format) {
      if (number_format == "#.#%") return "percent";
      if (number_format == "#,###.##") return "decimal";
      if (number_format == "#") return "decimal";
    },
    bgColor: function (color) {
      return `bg-[${color}]`;
    }
  }
};
</script>
